var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "componentRef", staticClass: "contact-detail-item" },
    [
      _c(
        "div",
        { staticClass: "contact-detail-item-details" },
        [
          _vm.field === "vipCustomer"
            ? [
                _c(
                  "div",
                  { staticClass: "contact-detail-item-input vip-customer" },
                  [
                    _c(
                      "div",
                      { staticClass: "contact-detail-item-input-label" },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                  delay: [600, 0],
                                },
                                expression:
                                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                              },
                            ],
                            class: {
                              "material-icons": true,
                              vip: _vm.contact.vipCustomer,
                            },
                            attrs: {
                              content: _vm.$t("message.vipCustomer") + " ",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        star\n                    "
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.label) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "contact-detail-item-input-val" },
                      [
                        _c("a-switch", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                delay: [600, 0],
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                            },
                          ],
                          attrs: {
                            checked: _vm.value,
                            content: _vm.getSwitchTippyValue(),
                          },
                          on: { change: _vm.saveVipCustomer },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : _vm.field === "owner"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "contact-detail-item-input owner",
                    on: {
                      click: function () {
                        _vm.editModal = true
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                              delay: [600, 0],
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                          },
                        ],
                        staticClass: "contact-detail-item-icon",
                        attrs: { content: _vm.getOwnerTippyValue() },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("person_pin"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "contact-detail-item-input owner-field" },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                  delay: [600, 0],
                                },
                                expression:
                                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                              },
                            ],
                            staticClass: "contact-detail-item-input-label",
                            attrs: { content: _vm.getOwnerTippyValue() },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.label) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "contact-detail-item-input-val d-flex justify-content-between align-items-center",
                          },
                          [
                            _c("div", { staticClass: "owner-content" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                        delay: [600, 0],
                                      },
                                      expression:
                                        "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                                    },
                                  ],
                                  attrs: { content: _vm.getOwnerTippyValue() },
                                },
                                [
                                  _vm.value
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "owner-info" },
                                          [
                                            _c("AgentAvatar", {
                                              attrs: {
                                                userID: _vm.value,
                                                size: 24,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "owner-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getOwnerName(_vm.value)
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.$t("message.unowned")) +
                                            "\n                                "
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.value
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            delay: [600, 0],
                                          },
                                          expression:
                                            "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                                        },
                                      ],
                                      staticClass: "set-unowned",
                                      attrs: {
                                        content: _vm.$t(
                                          "chat.contactDetailItem.removeOwnership"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return function (event) {
                                            event.stopPropagation()
                                            _vm.saveOwner("")
                                          }.apply(null, arguments)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "material-icons" },
                                        [_vm._v("close")]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            delay: [600, 0],
                                          },
                                          expression:
                                            "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                                        },
                                      ],
                                      staticClass: "set-unowned",
                                      attrs: {
                                        content: _vm.$t(
                                          "chat.contactDetailItem.assignOwnershipToMe"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return function (event) {
                                            event.stopPropagation()
                                            _vm.saveOwner(_vm.user._id)
                                          }.apply(null, arguments)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "material-icons" },
                                        [_vm._v("assignment_ind")]
                                      ),
                                    ]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "edit-icon" },
                              [_c("a-icon", { attrs: { type: "edit" } })],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "contact-detail-item-icon" },
                  [_vm._t("icon")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "contact-detail-item-input" }, [
                  _c(
                    "div",
                    { staticClass: "contact-detail-item-input-label" },
                    [_vm._v(_vm._s(_vm.label))]
                  ),
                  _vm._v(" "),
                  _vm.value != null
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                delay: [600, 0],
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                            },
                          ],
                          staticClass: "contact-detail-item-input-val",
                          attrs: { content: _vm.getTippyValue() },
                        },
                        [
                          _vm.field === "tags"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "tags-container" },
                                  _vm._l(_vm.mappedTags, function (tag) {
                                    return _c(
                                      "span",
                                      {
                                        key: tag._id,
                                        staticClass: "tag-label",
                                        style: _vm.getTagStyle(tag.color),
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "remove-tag",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeTag(tag._id)
                                              },
                                            },
                                          },
                                          [_vm._v("×")]
                                        ),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(tag.name) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            : _vm.inputType === "json"
                            ? [
                                _c(
                                  "button",
                                  {
                                    staticClass: "classic-button visitor-attr",
                                    on: {
                                      click: function ($event) {
                                        _vm.JSONModal = true
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("message.jsonPreview")) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.JSONModal
                                  ? _c(
                                      "Modal2",
                                      {
                                        attrs: {
                                          title: _vm.label,
                                          "show-footer": false,
                                        },
                                        on: {
                                          cancel: function ($event) {
                                            _vm.JSONModal = false
                                          },
                                        },
                                      },
                                      [
                                        _c("prism-editor", {
                                          staticClass: "my-editor",
                                          attrs: {
                                            value: _vm.editedValue,
                                            "line-numbers": false,
                                            highlight: _vm.highlighter,
                                            readonly: "",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "SupsisButton",
                                              {
                                                on: {
                                                  click: _vm.copyJsonToken,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("message.copy"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "SupsisButton",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    _vm.JSONModal = false
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("message.cancel")
                                                    )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm.inputType === "date"
                            ? [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm
                                        .$moment(_vm.value)
                                        .format("DD/MM/YYYY")
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            : _vm.inputType === "url"
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass: "url-link",
                                    attrs: {
                                      href: _vm.getUrlHref(_vm.value),
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.value) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm.inputType === "agent"
                            ? [
                                _vm.value
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "owner-content d-flex align-items-center",
                                      },
                                      [
                                        _c("AgentAvatar", {
                                          attrs: {
                                            userID: _vm.value,
                                            size: 24,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "owner-name ml-1" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getOwnerName(_vm.value)
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : [_vm._v("-")],
                              ]
                            : [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.maskContactInfo(
                                        _vm.field,
                                        _vm.value,
                                        5
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ],
                        ],
                        2
                      )
                    : _vm.showAdd
                    ? _c(
                        "div",
                        {
                          staticClass: "contact-detail-item-input-val add-link",
                          on: { click: _vm.showAddModal },
                        },
                        [
                          _vm._v(
                            "\n                    + " +
                              _vm._s(_vm.$t("message.add")) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.value != null &&
      _vm.inputType !== "switch" &&
      _vm.inputType !== "select"
        ? _c(
            "div",
            { staticClass: "contact-detail-item-actions" },
            [
              _vm.isCompactView
                ? [
                    _c(
                      "a-popover",
                      {
                        attrs: {
                          overlayClassName: "actionSettingsButton",
                          placement: "bottomRight",
                          title: "",
                          trigger: "click",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c("div", { staticClass: "more-actions" }, [
                                    _vm.showEdit &&
                                    !(
                                      _vm.isShouldMask(_vm.value) ||
                                      _vm.isMaskContactInfo(_vm.field)
                                    )
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "action-button edit-btn",
                                            on: { click: _vm.handleEdit },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "material-icons" },
                                              [_vm._v("edit")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "action-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("message.edit"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showDelete
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "action-button delete-button",
                                            on: { click: _vm.showDeleteModal },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "material-icons" },
                                              [_vm._v("delete")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "action-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("chatbotv2.delete")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showCopy
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "action-button copy-btn",
                                            on: { click: _vm.copyValue },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "material-icons" },
                                              [_vm._v("content_copy")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "action-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.duplicate")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          4092675945
                        ),
                        model: {
                          value: _vm.isPopoverVisible,
                          callback: function ($$v) {
                            _vm.isPopoverVisible = $$v
                          },
                          expression: "isPopoverVisible",
                        },
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "conversation-actions-button more-vert",
                          },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("more_vert"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                : [
                    _c("div", { staticClass: "action-buttons" }, [
                      _vm.showEdit &&
                      !(
                        _vm.isShouldMask(_vm.value) ||
                        _vm.isMaskContactInfo(_vm.field)
                      )
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: { content: _vm.$t("message.edit") },
                                  expression: "{ content: $t('message.edit') }",
                                },
                              ],
                              staticClass: "action-button edit-btn",
                              on: { click: _vm.handleEdit },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("edit"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDelete
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.$t("chatbotv2.delete"),
                                  },
                                  expression:
                                    "{ content: $t('chatbotv2.delete') }",
                                },
                              ],
                              staticClass: "action-button delete-button",
                              on: { click: _vm.showDeleteModal },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showCopy
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.$t("message.duplicate"),
                                  },
                                  expression:
                                    "{ content: $t('message.duplicate') }",
                                },
                              ],
                              staticClass: "action-button copy-btn",
                              on: { click: _vm.copyValue },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("content_copy"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
              _vm._v(" "),
              _vm._t("actions"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editModal && _vm.field === "owner"
        ? _c(
            "Modal2",
            {
              key: "owner-modal" + _vm.contact._id + _vm.editModal,
              attrs: {
                title: _vm.$t("message.transferOwnership"),
                showFooter: false,
                xlarge: "",
              },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c("ChatForwardWindow", {
                attrs: { contact: _vm.contact },
                on: {
                  close: function () {
                    _vm.editModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editModal && _vm.field === "vipCustomer"
        ? _c(
            "Modal2",
            {
              key: "vip-customer-modal" + _vm.contact._id,
              attrs: {
                title: _vm.$t("chat.contactDetailItem.vipCustomer"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { id: "vip-customer-modal-content" } },
                [
                  _c("div", { staticClass: "description" }),
                  _vm._v(" "),
                  _c("a-switch", {
                    model: {
                      value: _vm.editedValue,
                      callback: function ($$v) {
                        _vm.editedValue = $$v
                      },
                      expression: "editedValue",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-actions" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          on: {
                            click: function ($event) {
                              _vm.editModal = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        { attrs: { primary: "" }, on: { click: _vm.saveEdit } },
                        [_vm._v(_vm._s(_vm.$t("message.update")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _vm.editModal && !_vm.isSpecialField
        ? _c(
            "Modal2",
            {
              key: "edit-modal" + _vm.contact._id,
              attrs: {
                title: _vm.$t("message.edit") + ": " + _vm.label,
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { id: "contact-property-modal-content" } },
                [
                  _vm.inputType === "dropdown"
                    ? [
                        _c(
                          "a-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: _vm.value,
                              "show-search": "",
                              "filter-option": _vm.filterOption,
                              placeholder: _vm.$t("message.search"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.editedValue = $event
                              },
                            },
                          },
                          _vm._l(_vm.options, function (option) {
                            return _c(
                              "a-select-option",
                              { key: option, attrs: { value: option } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(option) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ]
                    : _vm.inputType === "json"
                    ? [
                        _c("prism-editor", {
                          staticClass: "json-editor",
                          attrs: { highlight: _vm.highlighter },
                          model: {
                            value: _vm.editedValue,
                            callback: function ($$v) {
                              _vm.editedValue = $$v
                            },
                            expression: "editedValue",
                          },
                        }),
                      ]
                    : _vm.inputType === "date"
                    ? [
                        _c("a-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            value: _vm.editedValue
                              ? _vm.$moment(_vm.editedValue)
                              : null,
                            format: "DD/MM/YYYY",
                          },
                          on: {
                            change: function (date) {
                              _vm.editedValue = date ? date.toISOString() : ""
                            },
                          },
                        }),
                      ]
                    : _vm.inputType === "agent"
                    ? [
                        _c("AgentPicker", {
                          attrs: {
                            single: true,
                            value: _vm.agentPickerFromId(_vm.editedValue),
                          },
                          on: { input: _vm.onAgentEditPickerInput },
                        }),
                      ]
                    : [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.editedValue,
                              expression: "editedValue",
                            },
                          ],
                          attrs: {
                            placeholder: _vm.$t("message.enterNewValue"),
                          },
                          domProps: { value: _vm.editedValue },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.editedValue = $event.target.value
                            },
                          },
                        }),
                      ],
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-actions" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          on: {
                            click: function ($event) {
                              _vm.editModal = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveEdit },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.update")))]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _vm.editModal && _vm.field === "preferredLang"
        ? _c(
            "Modal2",
            {
              key: "preferred-lang-modal" + _vm.contact._id,
              attrs: {
                title: _vm.$t("message.updatePreferredLanguage"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c("UpdateContactLang", {
                attrs: { contact: _vm.contact },
                on: {
                  close: function ($event) {
                    _vm.editModal = false
                  },
                  save: _vm.savePreferredLang,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _vm.editModal && _vm.field === "tags"
        ? _c(
            "Modal2",
            {
              key: "tags-modal" + _vm.contact._id,
              attrs: { title: _vm.$t("message.updateTags"), showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c("TagDialog", {
                attrs: { value: _vm.getContactTagIds(), inlineMode: true },
                on: {
                  input: _vm.saveTagsUpdate,
                  close: function ($event) {
                    _vm.editModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _vm.editModal && _vm.field === "email"
        ? _c(
            "Modal2",
            {
              key: "email-modal" + _vm.contact._id,
              attrs: {
                title: _vm.$t("message.updateEmail"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c("div", { attrs: { id: "contact-property-modal-content" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedValue,
                      expression: "editedValue",
                    },
                  ],
                  attrs: {
                    type: "email",
                    placeholder: _vm.$t("message.enterNewEmail"),
                  },
                  domProps: { value: _vm.editedValue },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.editedValue = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                !_vm.editedValue.includes("@")
                  ? _c(
                      "div",
                      { staticClass: "email-suggestions" },
                      _vm._l(_vm.emailDomains, function (domain) {
                        return _c(
                          "span",
                          {
                            key: domain,
                            on: {
                              click: function ($event) {
                                return _vm.appendEmailDomain(domain)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.editedValue) +
                                _vm._s(domain) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        on: {
                          click: function ($event) {
                            _vm.editModal = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveEdit },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.update")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _vm.addModal
        ? _c(
            "Modal2",
            {
              key: "add-modal" + _vm.contact._id,
              attrs: {
                title: _vm.$t("message.add") + ": " + _vm.label,
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.addModal = false
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { id: "contact-property-modal-content" } },
                [
                  _vm.inputType === "dropdown"
                    ? [
                        _c(
                          "a-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "show-search": "",
                              "filter-option": _vm.filterOption,
                              placeholder: _vm.$t("message.search"),
                            },
                            model: {
                              value: _vm.newValue,
                              callback: function ($$v) {
                                _vm.newValue = $$v
                              },
                              expression: "newValue",
                            },
                          },
                          _vm._l(_vm.options, function (option) {
                            return _c(
                              "a-select-option",
                              { key: option, attrs: { value: option } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(option) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ]
                    : _vm.inputType === "json"
                    ? [
                        _c("prism-editor", {
                          staticClass: "json-editor",
                          attrs: { highlight: _vm.highlighter },
                          model: {
                            value: _vm.newValue,
                            callback: function ($$v) {
                              _vm.newValue = $$v
                            },
                            expression: "newValue",
                          },
                        }),
                      ]
                    : _vm.inputType === "date"
                    ? [
                        _c("a-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            value: _vm.newValue
                              ? _vm.$moment(_vm.newValue)
                              : null,
                            format: "DD/MM/YYYY",
                          },
                          on: {
                            change: function (date) {
                              _vm.newValue = date ? date.toISOString() : ""
                            },
                          },
                        }),
                      ]
                    : _vm.inputType === "agent"
                    ? [
                        _c("AgentPicker", {
                          attrs: {
                            single: true,
                            value: _vm.agentPickerFromId(_vm.newValue),
                          },
                          on: { input: _vm.onAgentAddPickerInput },
                        }),
                      ]
                    : [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newValue,
                              expression: "newValue",
                            },
                          ],
                          attrs: {
                            placeholder: _vm.$t("message.enterNewValue"),
                          },
                          domProps: { value: _vm.newValue },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.newValue = $event.target.value
                            },
                          },
                        }),
                      ],
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-actions" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          on: {
                            click: function ($event) {
                              _vm.addModal = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveAdd },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.add")))]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _vm.deleteModal
        ? _c(
            "Modal2",
            {
              key: "delete-modal" + _vm.contact._id,
              attrs: {
                title: _vm.$t("message.deleteConfirmation"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.deleteModal = false
                },
              },
            },
            [
              _c("div", { attrs: { id: "contact-property-modal-content" } }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("message.confirmDelete")))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        on: {
                          click: function ($event) {
                            _vm.deleteModal = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmDelete },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.yesDelete")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }